import { render, staticRenderFns } from "./corporates.vue?vue&type=template&id=fe239292&"
import script from "./corporates.vue?vue&type=script&lang=js&"
export * from "./corporates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports